<template>
  <div>
    <b-dropdown class="logout">
      <template v-slot:button-content>
        <span class="d-flex align-self-center my-1 justify-content-center">
          <img height="64" src="@/assets/icons/avatar.svg">
        </span>
        <span class="mx-2 mt-3 d-flex align-self-center justify-content-center">
          {{ displayName }}
        </span>
      </template>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item @click="userProfile" class="text-muted">
        <i class="text-muted icon icon-cog"></i>
        {{$t('UserProfile.Common.Profile')}}
      </b-dropdown-item>
      <b-dropdown-item @click="userLogout">
        <i class="text-muted icon icon-logout"></i>
        {{$t('header.logout')}}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>



<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'LogoutForm',
    computed: {
      ...mapGetters({
        tenantDesignConfig: 'tenantDesign/config',
        userInfo: 'userDemographic/userInfo',
        isUserLoggedIn: 'auth/isUserAuthenticated',
        portalConfigurations: 'tenantDesign/config'
      }),
      portalGeneralInfo() {
        return this.portalConfigurations.general
      },
      tenantLoginType() {
        return this.tenantDesignConfig.userManagement.loginType.toLowerCase()
      },
      displayName() {
        return this.userInfo.username ? this.userInfo.username : this.userInfo.email
      }
    },
    methods: {
      ...mapActions({
        logout: 'auth/logout',
        loadUserInfo: 'userDemographic/loadUserInfo'
      }),
      setInitialData() {
        this.loadUserInfo().then(response => {

        })
      },
      login() {
        this.$router.push({ name: 'login' })
      },
      userLogout() {
        this.logout()
        window.location.href = window.location.origin
      },
      userProfile() {
        this.$router.push({ name: 'profile' })
      }
    },
    created() {
      if (this.isUserLoggedIn) {
        this.setInitialData()
      }
    },
    mounted() {
      if (this.isUserLoggedIn) {
        this.setInitialData()
      }
    },
  }
</script>
